<div class="landing-toolbar">

    <logo class="landing-toolbar-logo">
    </logo>

    @let customerFullName = customerFullName$ | async;

    @if (customerFullName != null) {
    <rpc-avatar class="landing-toolbar-avatar" [userFullName]="customerFullName" [useBackgroundImage]="true"
        [profileImageUrl]="customerProfileImage$ | async" [title]="customerFullName" (click)="onMyProfileClicked()">
    </rpc-avatar>
    }

</div>